export const CREATOR_UNKNOWN = 'unknown' as const;
export const DEFAULT_MEASUREMENT_UNIT = 'IN' as const;

export const FREE_SHIPPING = 'FREE_SHIPPING' as const;
export const FREE_SHIPPING_AND_COST = 'FREE_SHIPPING_AND_COST' as const;
export const DEFAULT_SHIPPING_BADGE_TYPE = FREE_SHIPPING;
export const QUICK_VIEW_TYPE_STATIC = 'static';
export const QUICK_VIEW_TYPE_DEFAULT = 'default';
export type QuickViewType = typeof QUICK_VIEW_TYPE_STATIC | typeof QUICK_VIEW_TYPE_DEFAULT;

export const WIDTH_STATIC_TILE_IMAGE = 240;
